import { FinecoDownloadIcon } from "shared/assets/svg/FinecoDownloadIcon";
import styles from "./finecoDownloadButton.module.scss";

type FinecoDownloadButtonProps = {
  click: () => void;
  copy: string;
  disabled?: boolean;
  white?: boolean;
};
export const FinecoDownloadButton: React.FC<FinecoDownloadButtonProps> = ({
  click,
  copy,
  disabled = false,
  white = false,
}) => {
  return (
    <div className={styles.buttonContainer}>
      <div className={styles.icon}>
        <FinecoDownloadIcon />
      </div>
      <div onClick={disabled ? undefined : click} className={styles.buttonCopy}>
        {copy}
      </div>
    </div>
  );
};
